import fscreen from "fscreen";
import { useState, useEffect, useCallback } from "react";
import { IGif } from "services/types";

interface IUseFullScreen {
  ref: any;
}

export const useFullScreen = ({ ref }: IUseFullScreen) => {
  const [inFullscreenMode, setInFullscreenMode] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [FSGif, setFSGif] = useState<IGif | null>(null);

  useEffect(() => {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener("fullscreenchange",handleFullscreenChange, false);
      fscreen.addEventListener("fullscreenerror", handleFullscreenError, false);

      return () => {
        fscreen.removeEventListener("fullscreenchange", handleFullscreenChange);
        fscreen.removeEventListener("fullscreenerror", handleFullscreenError);
      };
    }
  });

  useEffect(() => {
    if (inFullscreenMode) {
      document.body.classList.add("fullScreen");
    } else {
      document.body.classList.remove("fullScreen");
      window.scrollTo(0, scrollPosition);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inFullscreenMode]);

  const handleFullscreenChange = useCallback((e: any) => {
    if (fscreen.fullscreenElement !== null) {
      console.debug("Entered fullscreen mode", e);
      setInFullscreenMode(true);
    } else {
      console.debug("Exited fullscreen mode", e);
      setInFullscreenMode(false);
    }
  }, []);

  const handleFullscreenError = useCallback((e: any) => {
    console.debug("Fullscreen Error", e);
  }, []);

  const toggleFullscreen = useCallback((gif: IGif | null) => {
    const fsEnabled = fscreen.fullscreenEnabled;

    if (inFullscreenMode && !fsEnabled) {
      setFSGif(null);
      setInFullscreenMode(false);
    }

    if (!inFullscreenMode && !fsEnabled){
      setFSGif(gif);
      setInFullscreenMode(true);
      setScrollPosition(window.pageYOffset);
    }

    if (fsEnabled && inFullscreenMode) {
      setFSGif(null);
      fscreen.exitFullscreen();
    }

    if (fsEnabled && !inFullscreenMode) {
      setFSGif(gif);
      setScrollPosition(window.pageYOffset);
      fscreen.requestFullscreen(ref.current);
    }
  }, [inFullscreenMode, ref]);

  return {
    inFullscreenMode,
    toggleFullscreen,
    FSGif,
    fullscreenEnabled: fscreen.fullscreenEnabled
  };
};
